import { Route } from '../Routing/types';
import { DietSettingsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';
import stepsSchema from './stepsSchema';
import { DIET_TYPES_PL, DIET_TYPES_EN } from '../GoalSettings/consts';

const dummy_t = (translationKey: string) => translationKey;

const activeLang = localStorage.getItem('i18nextLng');

const routes: Route[] = [
  {
    path: '/diet-settings/nutritionSettings/*',
    element: (
      <DietSettingsPage
        descendantRoutes={descendantRoutes}
        stepsSchema={stepsSchema}
        currentMainStep="nutritionSettings"
        dietTypes={activeLang === 'pl-PL' ? DIET_TYPES_PL : DIET_TYPES_EN}
      />
    ),
    private: true,
    title: dummy_t('nutritionSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
